export default __webpack_public_path__ + "static/media/MU.c4aa8b71.svg";